import { Button, Modal, ModalProps, Stack, Textarea, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface PerformanceReviewCommentForReviewerModalProps extends ModalProps {
  initialComment: string;
  onSave: (comment: string) => void;
}

export function PerformanceReviewCommentForReviewerModal({
  initialComment,
  onSave,
  ...props
}: PerformanceReviewCommentForReviewerModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const [comment, setComment] = useState(initialComment);

  const hasComment = initialComment.length > 0;
  const title = hasComment ? t("performance_review:edit_focus") : t("performance_review:add_focus");

  const handleSave = () => {
    onSave(comment);
    close(props.id);
  };

  return (
    <Modal
      {...props}
      withCloser
      size={"lg"}
      title={title}
      actions={
        <Stack>
          <Button size={"lg"} onClick={handleSave}>
            {t("common:save")}
          </Button>
        </Stack>
      }
    >
      <Textarea
        label={t("performance_review:add_specific_focus")}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
    </Modal>
  );
}
